import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { PrescriptionResponse } from '@ca/common'

import Radio from '@ui/forms/Radio'
import { Pressable, View } from 'react-native'

import PrescriptionHead from '@screens/vision/prescription/view/PrescriptionHead'
import Refraction from '@screens/vision/prescription/view/sections/Refraction'
import Highlights from '@ui/effects/Highlights'
import { colors } from '@ui/colors'

interface Props {
  data: PrescriptionResponse
  isSelected: boolean
  onPress: () => void
}

const borderRadius = 24
const borderRadiuses = { borderRadius }
const pressableStyle = { borderRadius, overflow: 'hidden' as const }
const borderWidthActive = { borderWidth: 2 }
const borderWidthInactive = { borderWidth: 1 }

const highlightsLayers = {
  disabled: true,
  default: false,
  active: true,
  success: false,
  danger: false,
  attention: false,
}

export default function PrescriptionItem({ data, onPress, isSelected }: Props) {
  const {
    animation: animationPress,
    onPressIn,
    onPressOut,
  } = useAnimatedPress()

  return (
    <Pressable
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      onPress={onPress}
      style={pressableStyle}
    >
      <Highlights
        variant={isSelected ? 'active' : 'disabled'}
        layers={highlightsLayers}
        animationPress={animationPress}
        borderWidths={isSelected ? borderWidthActive : borderWidthInactive}
        borderRadiuses={borderRadiuses}
      />
      <PrescriptionHead data={data}>
        <Radio value={isSelected} colorActive={colors.blue[600]} />
      </PrescriptionHead>
      <View className="border-t border-black/10">
        <Refraction data={data} />
      </View>
    </Pressable>
  )
}
